import { useIsMobile } from './useIsMobile'

type MotionValueOption = Array<string | number> | any

export const useMotionValue = (value: MotionValueOption) => {
  const isMobile = useIsMobile()

  if (value instanceof Array) {
    return isMobile ? value[0] : value[1]
  }

  return value
}
